import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { BerService } from '../ber.service';
import { SzerkZar, SzerkZarService } from '../../components/szerk-zar/szerk-zar.service';

/**
 *  LETILTÁSOK – végrehajtási ügyek tételesen.
 *
 *  Egy ügy több tételből áll (készkiadás, költségátalány, perköltség, kamat, főkövetelés …), és
 *  minden tételnek MÁS a kedvezményezettje és a bankszámlája: a végrehajtói iroda a saját
 *  költségeit kapja, a jogosult a követelését. A havi levonás ezek közt oszlik szét kielégítési
 *  sorrendben – ezt a kiszolgáló számolja (ber-letiltas.js), a Vht. 61–65. §-ának korlátaival.
 */
@Component({
  selector: 'app-ber-letiltas',
  templateUrl: './letiltas.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../ber-shared.scss', './letiltas.component.scss'],
})
export class BerLetiltasComponent implements OnInit, OnDestroy {
  intezmeny = '';
  alkalmazottak: any[] = [];
  alkalmazottId = '';
  ugyek: any[] = [];
  torzsek: { tetelTipusok: any[]; csoportok: any[] } = { tetelTipusok: [], csoportok: [] };
  betoltes = false;
  nezet: 'ugyek' | 'utalas' | 'proba' = 'ugyek';

  /** A szerkesztett ügy és tétel (modál helyett helyben, mert a tételsor sok mezőt kér). */
  szerk: any = null;
  tetelSzerk: any = null;
  /** Korábbi (visszamenőleges) levonás rögzítése: { ugy, ev, ho, tetelek:[{tetel_id, nev, hatralek, osszeg}], osszesen, megjegyzes } */
  korabbi: any = null;
  nyitott: Record<string, boolean> = {};

  /** Próbaszámítás: adott nettóból mi lenne a levonás. */
  probaNetto: number | null = null;
  proba: any = null;

  /** Utalási lista. */
  ev = new Date().getFullYear();
  ho = new Date().getMonth() + 1;
  utalasok: any[] = [];
  utalasOsszesen = 0;

  constructor(private ber: BerService, private toast: ToastController, private alert: AlertController, private szerkZar: SzerkZarService) {}

  /*  SZERKESZTÉSI ZÁR (components/szerk-zar) a meglévő ügyre és tételre: egyszerre egy ember
   *  szerkesztheti. A sorszám a késve érkező foglalást dobja el, ha a szerkesztőt közben bezárták. */
  zarUgy: SzerkZar | null = null;
  zarTetel: SzerkZar | null = null;
  private zarSorsz = { zarUgy: 0, zarTetel: 0 };
  private async zarFoglal(mezo: 'zarUgy' | 'zarTetel', tipus: string, id: string, ujratolt: () => unknown) {
    this.zarEngedi(mezo);
    const s = this.zarSorsz[mezo];
    const z = await this.szerkZar.foglal('ber', tipus, id, { ujratolt });
    if (s !== this.zarSorsz[mezo]) { z?.felenged(); return; }
    this[mezo] = z;
  }
  private zarEngedi(mezo: 'zarUgy' | 'zarTetel') { this.zarSorsz[mezo]++; this[mezo]?.felenged(); this[mezo] = null; }
  /** Az ügy-szerkesztő bezárása (Bezár, a modál eltűnése, sikeres mentés). */
  ugyBezar() { this.szerk = null; this.zarEngedi('zarUgy'); }
  tetelBezar() { this.tetelSzerk = null; this.zarEngedi('zarTetel'); }
  ngOnDestroy() { this.zarEngedi('zarUgy'); this.zarEngedi('zarTetel'); }

  get aktiv() { return this.ber.aktiv; }
  api(p: string) { return `/api/ber-letiltas${p}`; }

  async ngOnInit() {
    const a = await this.ber.init();
    this.intezmeny = a.intezmeny;
    try { this.torzsek = await this.ber.letiltasApi.get('/torzsek'); } catch { /* marad üres */ }
    await this.alkalmazottakBetolt();
  }

  private async alkalmazottakBetolt() {
    if (!this.aktiv.ugyfelId) return;
    try {
      const r: any = await this.ber.get(`/alkalmazottak/${this.aktiv.ugyfelId}`);
      this.alkalmazottak = Array.isArray(r) ? r : (r?.sorok || []);
      if (!this.alkalmazottId && this.alkalmazottak.length) this.alkalmazottId = this.alkalmazottak[0].id;
      await this.betolt();
    } catch { this.hiba('Nem sikerült betölteni az alkalmazottakat.'); }
  }

  /*  VISSZANÉZÉS: üres = mai állapot; kiválasztott hónapnál a hónap végi állapot (addigi levonások,
   *  a hónap végéig számolt kamat) és tételenként a hónap levonása. */
  visszaEv: number | null = null;
  visszaHo: number | null = null;
  readonly evek = Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - i);
  honapAllapot: any = null;
  async visszaValt() { if (this.visszaEv && !this.visszaHo) this.visszaHo = new Date().getMonth() + 1; await this.betolt(); }
  async maiAllapot() { this.visszaEv = null; this.visszaHo = null; await this.betolt(); }

  async betolt() {
    if (!this.alkalmazottId) { this.ugyek = []; return; }
    this.betoltes = true;
    try {
      const q = this.visszaEv && this.visszaHo ? `?ev=${this.visszaEv}&ho=${this.visszaHo}` : '';
      const r: any = await this.ber.letiltasApi.get(`/ugyek/${this.alkalmazottId}${q}`);
      this.honapAllapot = r.honap || null;
      this.ugyek = r.ugyek || [];
      this.proba = null;
    } catch { this.hiba('Nem sikerült betölteni a letiltásokat.'); }
    finally { this.betoltes = false; }
  }

  /* ── ügy ── */
  ujUgy() {
    this.zarEngedi('zarUgy');
    this.szerk = { alkalmazott_id: this.alkalmazottId, csoport: 'egyeb', allapot: 'aktiv', jutalek_szazalek: 8 };
  }
  szerkeszt(u: any) {
    this.szerk = { ...u, tetelek: undefined };
    this.zarFoglal('zarUgy', 'ber_letiltas_ugy', u.id, async () => {
      await this.betolt();
      const friss = this.ugyek.find((x) => x.id === u.id);
      if (friss && this.szerk?.id === u.id) this.szerk = { ...friss, tetelek: undefined };
    });
  }
  async ugyMent() {
    const u = this.szerk;
    if (this.zarUgy && !this.zarUgy.irhato) return;
    try {
      if (u.id) await this.ber.letiltasApi.put(`/ugy/${u.id}`, u);
      else await this.ber.letiltasApi.post('/ugy', { ...u, alkalmazott_id: this.alkalmazottId });
      this.ugyBezar();
      await this.betolt();
      this.ok('Mentve.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }
  async ugyTorol(u: any) {
    if (!(await this.megerosit(`Törlöd a(z) ${u.ugyszam || 'letiltás'} ügyet?`))) return;
    try { await this.ber.letiltasApi.del(`/ugy/${u.id}`); await this.betolt(); this.ok('Törölve.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült törölni.'); }
  }

  /* ── tétel ── */
  ujTetel(u: any) {
    this.zarEngedi('zarTetel');
    const t = this.torzsek.tetelTipusok[0] || { kulcs: 'egyeb' };
    this.tetelSzerk = { ugy_id: u.id, tipus: t.kulcs, sorrend: t.sorrend, jutalek_alap: t.jutalekAlap,
      kedvezmenyezett: t.kinek === 'vegrehajto' ? u.vegrehajto : u.jogosult, kozlemeny: u.ugyszam };
    this.nyitott[u.id] = true;
  }
  /*  Típusváltáskor a sorrend, a jutalékalap és a kedvezményezett is követi a típust: a
   *  végrehajtói iroda a saját költségeit kapja, a jogosult a követelését. */
  tipusValt() {
    const t = this.torzsek.tetelTipusok.find((x) => x.kulcs === this.tetelSzerk.tipus);
    if (!t) return;
    this.tetelSzerk.sorrend = t.sorrend;
    this.tetelSzerk.jutalek_alap = t.jutalekAlap;
    const u = this.ugyek.find((x) => x.id === this.tetelSzerk.ugy_id);
    if (u) this.tetelSzerk.kedvezmenyezett = t.kinek === 'vegrehajto' ? u.vegrehajto : u.jogosult;
  }
  tetelSzerkeszt(t: any) {
    this.tetelSzerk = { ...t };
    this.zarFoglal('zarTetel', 'ber_letiltas_tetel', t.id, async () => {
      await this.betolt();
      const friss = this.ugyek.flatMap((u) => u.tetelek || []).find((x: any) => x.id === t.id);
      if (friss && this.tetelSzerk?.id === t.id) this.tetelSzerk = { ...friss };
    });
  }
  async tetelMent() {
    const t = this.tetelSzerk;
    if (this.zarTetel && !this.zarTetel.irhato) return;
    try {
      if (t.id) await this.ber.letiltasApi.put(`/tetel/${t.id}`, t);
      else await this.ber.letiltasApi.post('/tetel', t);
      this.tetelBezar();
      await this.betolt();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni a tételt.'); }
  }
  async tetelTorol(t: any) {
    if (!(await this.megerosit('Törlöd a tételt?'))) return;
    try { await this.ber.letiltasApi.del(`/tetel/${t.id}`); await this.betolt(); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült törölni.'); }
  }

  /* ── próba és utalás ── */
  async probaSzamol() {
    if (!(this.probaNetto! > 0)) return;
    try { this.proba = await this.ber.letiltasApi.post(`/proba/${this.alkalmazottId}`, { netto: this.probaNetto, ev: this.ev }); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült kiszámolni.'); }
  }
  async utalasBetolt() {
    if (!this.aktiv.ugyfelId) return;
    try {
      const r: any = await this.ber.letiltasApi.get(`/utalasok/${this.aktiv.ugyfelId}?ev=${this.ev}&ho=${this.ho}`);
      this.utalasok = r.utalasok || [];
      this.utalasOsszesen = r.osszesen || 0;
    } catch { this.hiba('Nem sikerült betölteni az utalási listát.'); }
  }
  nezetValt(n: 'ugyek' | 'utalas' | 'proba') { this.nezet = n; if (n === 'utalas') this.utalasBetolt(); }

  /* ── összegzők a fejléc csempéihez ── */
  get aktivDb() { return this.ugyek.filter((u) => u.allapot === 'aktiv').length; }
  get szunetelDb() { return this.ugyek.filter((u) => u.allapot === 'felfuggesztve').length; }
  get honapLevonas() { return this.ugyek.reduce((n, u) => n + Number(u.honap_levonas || 0), 0); }
  get osszesHatralek() { return this.ugyek.reduce((n, u) => n + Number(u.hatralek || 0), 0); }
  koveteles(u: any) { return (u.tetelek || []).reduce((n: number, t: any) => n + Number(t.koveteles_szamitott ?? t.osszeg ?? 0), 0); }
  teljesitett(u: any) { return (u.tetelek || []).reduce((n: number, t: any) => n + Number(t.teljesitve || 0), 0); }
  get osszesTeljesitve() { return this.ugyek.reduce((n, u) => n + this.teljesitett(u), 0); }
  get szazalekTeljesitve() {
    const k = this.ugyek.reduce((n, u) => n + this.koveteles(u), 0);
    return k > 0 ? Math.round((this.osszesTeljesitve / k) * 100) : 0;
  }
  /** Az ügy teljesítettsége százalékban (a sávhoz). */
  arany(u: any) { const k = this.koveteles(u); return k > 0 ? Math.min(100, Math.round((this.teljesitett(u) / k) * 100)) : 0; }

  /** A legutóbbi hónap összes levonása – a fejléc csempéjéhez. */
  get utolsoHavi(): { ev: number; ho: number; osszeg: number } | null {
    let legfrissebb: { ev: number; ho: number; osszeg: number } | null = null;
    for (const u of this.ugyek) {
      for (const t of u.tetelek || []) {
        for (const h of t.teljesitesek || []) {
          if (!legfrissebb || h.ev > legfrissebb.ev || (h.ev === legfrissebb.ev && h.ho > legfrissebb.ho)) {
            legfrissebb = { ev: h.ev, ho: h.ho, osszeg: 0 };
          }
        }
      }
    }
    if (!legfrissebb) return null;
    for (const u of this.ugyek) {
      for (const t of u.tetelek || []) {
        for (const h of t.teljesitesek || []) {
          if (h.ev === legfrissebb.ev && h.ho === legfrissebb.ho) legfrissebb.osszeg += Number(h.osszeg || 0);
        }
      }
    }
    return legfrissebb;
  }

  korabbiNyit(u: any) {
    const ma = new Date();
    const elozo = new Date(ma.getFullYear(), ma.getMonth() - 1, 1);
    this.korabbi = {
      ugy: u, ev: elozo.getFullYear(), ho: elozo.getMonth() + 1, osszesen: null, megjegyzes: '',
      //  A havonta számolt kamat nem, a jutalék igen – a végrehajtói kimutatásban külön sorként szerepel.
      tetelek: (u.tetelek || []).filter((t: any) => t.szamitott !== 'kamat')
        .map((t: any) => ({ tetel_id: t.id, nev: t.megnevezes || this.tipusNev(t.tipus), hatralek: t.hatralek, szamitott: t.szamitott, osszeg: null })),
    };
  }
  get korabbiOsszeg(): number { return (this.korabbi?.tetelek || []).reduce((n: number, t: any) => n + (Number(t.osszeg) || 0), 0); }
  /** Egyszerű szétosztás a kielégítési sorrendben, a tételek hátralékáig (a jutalékot kézzel kell megadni). */
  korabbiSzetoszt() {
    let marad = Number(this.korabbi.osszesen) || 0;
    for (const t of this.korabbi.tetelek) {
      if (t.szamitott) { t.osszeg = null; continue; }
      const fiz = Math.max(0, Math.min(marad, t.hatralek == null ? marad : t.hatralek));
      t.osszeg = fiz || null; marad -= fiz;
    }
    if (marad > 0) this.hiba(`${this.szam(marad)} Ft nem fért el a tételek hátralékában.`);
  }
  async korabbiMent() {
    const k = this.korabbi;
    try {
      const r: any = await this.ber.letiltasApi.post('/teljesites-kezi', {
        ugy_id: k.ugy.id, ev: k.ev, ho: k.ho, megjegyzes: k.megjegyzes,
        tetelek: k.tetelek.filter((t: any) => Number(t.osszeg) > 0).map((t: any) => ({ tetel_id: t.tetel_id, osszeg: Number(t.osszeg) })),
      });
      this.korabbi = null;
      await this.betolt();
      this.ok(`${k.ev}. ${k.ho}. hó: ${this.szam(r.osszeg)} Ft rögzítve, hátralék: ${this.szam(r.hatralek)} Ft.`);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült rögzíteni.'); }
  }
  async korabbiTorol(u: any, h: any) {
    if (!(await this.megerosit(`Törlöd a(z) ${h.ev}. ${h.ho}. hónap kézzel rögzített levonásait?`))) return;
    try { await this.ber.letiltasApi.del(`/teljesites-kezi/${u.id}/${h.ev}/${h.ho}`); await this.betolt(); this.ok('Törölve.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült törölni.'); }
  }

  vanTeljesites(u: any) { return (u.tetelek || []).some((t: any) => (t.teljesitesek || []).length); }
  /** Az ügy havi kimutatása egy listában, hónap szerint rendezve. */
  havi(u: any) {
    const sorok: any[] = [];
    for (const t of u.tetelek || []) {
      for (const h of t.teljesitesek || []) {
        sorok.push({ ev: h.ev, ho: h.ho, osszeg: h.osszeg, maradek: h.maradek, kezi: !h.szamfejtes_id, megjegyzes: h.megjegyzes,
          megnevezes: t.megnevezes || this.tipusNev(t.tipus), kedvezmenyezett: t.kedvezmenyezett || '—' });
      }
    }
    sorok.sort((a, b) => a.ev - b.ev || a.ho - b.ho || String(a.megnevezes).localeCompare(String(b.megnevezes), 'hu'));
    //  A kézi hónap törlőgombja csak a hónap első sorában jelenik meg.
    const latott = new Set<string>();
    for (const s of sorok) { const k = `${s.ev}-${s.ho}`; s.elso = !latott.has(k); latott.add(k); }
    return sorok;
  }

  /* ── segédek ── */
  tipusNev(k: string) { return this.torzsek.tetelTipusok.find((x) => x.kulcs === k)?.nev || k; }
  csoportNev(k: string) { return this.torzsek.csoportok.find((x) => x.kulcs === k)?.nev || k; }
  allapotCimke(a: string) {
    return { aktiv: 'aktív', felfuggesztve: 'felfüggesztve', megszuntetve: 'megszüntetve', lezart: 'lezárt' }[a] || a;
  }
  szam(v: any) { return Math.round(Number(v) || 0).toLocaleString('hu-HU'); }
  private async megerosit(uzenet: string) {
    const a = await this.alert.create({ header: 'Megerősítés', message: uzenet,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Igen', role: 'confirm' }] });
    await a.present();
    return (await a.onDidDismiss()).role === 'confirm';
  }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2000, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 3500, color: 'danger' })).present(); }
}
